import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=0f829dc5&scoped=true"
import script from "./aside.vue?vue&type=script&lang=ts"
export * from "./aside.vue?vue&type=script&lang=ts"
import style0 from "./aside.vue?vue&type=style&index=0&id=0f829dc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f829dc5",
  null
  
)

export default component.exports